{
  "password-form": {
    "text": {
      "password": "Mot de passe",
      "password-confirmation": "Confirmation du mot de passe"
    }
  }
}
